import type { UseFormReturn } from 'react-hook-form';
import {
  Disclosure,
  DisclosureButton,
  Labeled,
  TextInputField,
} from '@sixui/ui';
import { useTranslation } from 'react-i18next';

import type { IContainerProps } from '~/components/utils/Container';
import type { IFormMode } from '~/helpers/types';
import type { IArticleFormValues } from './ArticleForm';
import { FormField } from '~/components/atoms/FormField';
import { FormSection } from '~/components/atoms/FormSection';
import { FormFileUploader } from '~/components/organisms/fields/FileUploader';

export type IArticleFormMainPictureSectionProps = IContainerProps & {
  mode: IFormMode;
  form: UseFormReturn<IArticleFormValues>;
  appId: string;
};

export const ArticleFormMainMediaSection: React.FC<
  IArticleFormMainPictureSectionProps
> = ({ sx, form, appId }) => {
  const { t } = useTranslation();

  return (
    <Disclosure
      sx={sx}
      defaultExpanded
      trigger={
        <DisclosureButton>
          {t('ArticleFormMainMediaSection.title')}
        </DisclosureButton>
      }
    >
      <FormSection sub>
        <Labeled
          label={
            form.watch('type') === 'article'
              ? t('ArticleFormMainMediaSection.field.main-media.label')
              : t('ArticleFormMainMediaSection.field.main-media.webviewLabel')
          }
          required
        >
          <FormFileUploader
            name="mainMedias"
            control={form.control}
            appId={appId}
            maxFiles={1}
            acceptTypes={['picture', 'video']}
            supportingText={t(
              'ArticleFormMainMediaSection.field.main-media.supporting-text',
            )}
          />
        </Labeled>
        {form.watch('type') === 'article' && (
          <>
            <Labeled label={t('common.caption')}>
              <FormField
                name="mainMediaCaption"
                control={form.control}
                as={TextInputField}
                forwardError
              />
            </Labeled>
            <Labeled
              label={t('ArticleFormMainMediaSection.field.feed-picture.label')}
            >
              <FormFileUploader
                name="feedPictures"
                control={form.control}
                appId={appId}
                maxFiles={1}
                acceptTypes={['picture']}
              />
            </Labeled>
          </>
        )}
      </FormSection>
    </Disclosure>
  );
};
